/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DialCode
 */
export interface DialCode {
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    dialCode: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DialCode
     */
    flag: string;
}

export function DialCodeFromJSON(json: any): DialCode {
    return DialCodeFromJSONTyped(json, false);
}

export function DialCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DialCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dialCode': json['dialCode'],
        'code': json['code'],
        'flag': json['flag'],
    };
}

export function DialCodeToJSON(value?: DialCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'dialCode': value.dialCode,
        'code': value.code,
        'flag': value.flag,
    };
}


